export default 
[
    {
      id: 1,
      modulo: "compras",
      cor: "#FF6347",
      icone: "fa fa-shopping-basket",
    },
    {
      id: 2,
      modulo: "bolsarpaestagio",
      cor: "#228B22",
      icone: "fa fa-address-card",
    },
    {
      id: 3,
      modulo: "cursoeventoservico",
      cor: "#6959CD",
      icone: "fa fa-graduation-cap",
    },
    {
      id: 4,
      modulo: "solpf",
      cor: "#c55403",
      icone: "fa fa-money",
    },
    {
      id: 5,
      modulo: "adiantamento",
      cor: "#ca056a",
      icone: "fa fa-money",
    },
    {
      id: 6,
      modulo: "reembolso",
      cor: "#712cff",
      icone: "fa fa-plane",
    },
    {
      id: 7,
      modulo: "faturamento",
      cor: "#f54ea1",
      icone: "fa fa-calculator",
    },
    {
      id: 8,
      modulo: "solImportacao",
      cor: "#567CD3",
      icone: "fa fa-ship",
    },
    {
      id: 9,
      modulo: "solpj",
      cor: "#32CD32",
      icone: "fa fa-money",
    },
    {
      id: 10,
      modulo: "reembolsoterceiro",
      cor: "#BA55D3",
      icone: "fa fa-money",
    },
    {
      id: 11,
      modulo: "pedidos",
      cor: "#FF6347",
      icone: "fa fa-shopping-cart",
    },
    {
      id: 12,
      modulo: "pesquisas",
      cor: "#129ac3",
      icone: "fa fa-list-alt",
    },
    {
      id: 13,
      modulo: "solpfExtrangeiro",
      cor: "#c55403",
      icone: "fa fa-money",
    },
    {
      id: 14,
      modulo: "solpjExtrangeiro",
      cor: "#32CD3",
      icone: "fa fa-money",
    },
    {
      id: 15,
      modulo: "soltransferencia",
      cor: "#46b8da",
      icone: "fa fa-refresh",
    },
    {
      id: 16,
      modulo: "solcancelamentocontrato",
      cor: "#8f46da",
      icone: "fa fa-address-card-o",
    },
    {
      id: 17,
      modulo: "projetosTerminando",
      cor: "#129ac3",
      icone: "fa fa-list-alt",
    }
]



// WEBPACK FOOTER //
// ./FrontEnd/js/solicitacao-cores.js